<template>
  <div class="separator">
    <div class="line"></div>
    <div class="text">או</div>
    <div class="line"></div>
  </div>
</template>

<script>

export default {
  name: 'OrSeparator',
};
</script>

<style lang="scss" scoped>
  @import '../scss/riseup-colors';

  .separator {
    margin: 25px 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;

    .line {
      height: 1px;
      width: 100%;
      background-color: $riseup_gray_1;
    }

    .text {
      padding: 0 23px;
      flex-grow: 0;
    }
  }

</style>
